/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Fast_Track_TitleInputs */

const en_directory_submit_review_fast_track_title = /** @type {(inputs: Directory_Submit_Review_Fast_Track_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast Track`)
};

const zh_directory_submit_review_fast_track_title = /** @type {(inputs: Directory_Submit_Review_Fast_Track_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速上线`)
};

/**
* | output |
* | --- |
* | "Fast Track" |
*
* @param {Directory_Submit_Review_Fast_Track_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_fast_track_title = /** @type {((inputs?: Directory_Submit_Review_Fast_Track_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Fast_Track_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_fast_track_title(inputs)
	return zh_directory_submit_review_fast_track_title(inputs)
});
export { directory_submit_review_fast_track_title as "directory.submit.review.fast_track_title" }